import App from "./modules/App";

let options = {};
if (typeof window.w4me_options !== 'undefined') {
    options = window.w4me_options;
    window.w4me_options = undefined;
}

let config = {
    is_dev: window.location.hostname === '127.0.0.1',
    logger: {
        target: 'console',
        logLevel: 'error'
    },
    navbar: {}
}

if (config.is_dev) {
    config.logger.logLevel = 'debug';
}

let app = new App(config);
if (config.is_dev) {
    window.w4me = app;
}
